import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUploadImageMutation = createMutationHook(OffersApiClient.uploadImage, {
  mutationKey: ['uploadImage'],
})
